import React from 'react';
import { OperationProgressWindowRequest } from '../../../../shared/ui/progress';
import type { QuickFillSyncProgress } from '../../../../shared/services/quickFillRevitService';
import { buildQuickFillApplyProgressModel } from '../../lib/quickFillOperationProgress';

interface QuickFillApplyProgressDialogProps {
  open: boolean;
  progress: QuickFillSyncProgress | null | undefined;
}

const QuickFillApplyProgressDialog: React.FC<QuickFillApplyProgressDialogProps> = ({
  open,
  progress,
}) => (
  <OperationProgressWindowRequest
    id="quick-fill-apply-progress"
    open={open}
    priority={80}
    model={buildQuickFillApplyProgressModel(progress)}
  />
);

export default QuickFillApplyProgressDialog;
